/* eslint-disable no-unused-vars */
import ImageUploading from 'react-images-uploading';
//import './ReactCrop.css';
import Resizer from 'react-image-file-resizer';
import { useSelector } from 'react-redux';
import { MEDIATYPES } from 'constants';
import { ImageUploadHandler } from './imageUploadHandler/ImageUploadHandler';
import { useSignal, useComputed } from '@preact/signals-react';
import { Each, Separators } from 'components';
import { ListItem } from '../generalModalUi/ListItem';
import * as S from './CreativeImageUploader.styled';

export const CreativeImageUploader = ({
  resolutionWidth,
  resolutionHeight,
  selectedFile$,
  selectedImgOrVideo$,
  filteredItems$,
  searchValue$,
  isImg,
  isVideo,
}) => {
  const imgIsLoading$ = useSignal(false);

  const creativeModalType = useSelector((state) => state.application.creativeModalType);

  const onChange = (imageList) => {
    imgIsLoading$.value = true;
    if (imageList.length > 0) {
      //Data for submit
      let newWidth = 512;
      let newHeight = 512;
      if (creativeModalType === MEDIATYPES.IMAGE_LANDSCAPE) {
        newWidth = 1200;
        newHeight = 628;
      }
      // Convert the data_url to a Blob
      const dataURL = imageList[imageList.length - 1]['data_url'];
      fetch(dataURL)
        .then((response) => response.blob())
        .then((blob) => {
          // Resize the Blob to 512
          Resizer.imageFileResizer(
            blob,
            newWidth, // Max width
            newHeight, // Max height
            'JPEG', // Output format (you can change this to 'PNG' if needed)
            100, // Image quality (0-100)
            0, // Rotation (0-360 degrees)
            (uri) => {
              // uri is the resized image as a data URL
              // Set the resized image as the source for cropping
              const newImageList = [{ data_url: uri }];
              selectedFile$.value = newImageList;
              // onImageUpload();
            },
            'base64', // Output type
          );
        })
        .catch((error) => {
          console.error('Error fetching and converting Blob:', error);
        });
    }
  };

  return (
    <>
      <div className='' style={{ flexGrow: '1' }}>
        <ImageUploading
          // value={selectedFile$.value}
          onChange={onChange}
          dataURLKey='data_url'
          acceptType={['png', 'jpg', 'jpeg']}
          resolutionWidth={resolutionWidth}
          resolutionHeight={resolutionHeight}
          resolutionType='more'
        >
          {({ onImageUpload, isDragging, dragProps, errors }) => {
            return (
              <div {...dragProps}>
                <ImageUploadHandler
                  selectedImgOrVideo$={selectedImgOrVideo$}
                  isDragging={isDragging}
                  dragProps={dragProps}
                  errors={errors}
                  onImageUpload={onImageUpload}
                  imgIsLoading$={imgIsLoading$}
                  resolutionWidth={resolutionWidth}
                  resolutionHeight={resolutionHeight}
                />
                <Separators type={Separators.separatorTypes.small} />
                {useComputed(() => {
                  if (filteredItems$.value?.length) {
                    return (
                      <S.ItemsContainer>
                        <Each
                          fieldOfIndex='media_id'
                          of={filteredItems$.value}
                          render={(item, index) => {
                            return (
                              <ListItem
                                creativeModalType={creativeModalType}
                                selectedImgOrVideo$={selectedImgOrVideo$}
                                item={item}
                                searchValue$={searchValue$}
                                isImg={isImg}
                                isVideo={isVideo}
                              />
                            );
                          }}
                        />
                      </S.ItemsContainer>
                    );
                  }
                })}
              </div>
            );
          }}
        </ImageUploading>
      </div>
    </>
  );
};
